import React from "react";
import { Col, Row } from "reactstrap";

const Footer = () => {
  const footerStyle = {
    background: "linear-gradient(135deg, #2d3436 0%, #1a1e21 100%)",
    color: "#ffffff",
    padding: "50px 40px 30px",
    marginTop: "50px",
  };

  const sectionTitleStyle = {
    fontSize: "1.1rem",
    fontWeight: "600",
    marginBottom: "20px",
    color: "#ffffff",
  };

  const linkStyle = {
    color: "rgba(255, 255, 255, 0.8)",
    textDecoration: "none",
    fontSize: "0.95rem",
    display: "block",
    marginBottom: "10px",
    transition: "color 0.3s ease",
  };

  const iconStyle = {
    fontSize: "1.5rem",
    marginRight: "10px",
    color: "#e63946",
  };

  return (
    <footer style={footerStyle}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <Row>
          <Col lg="4" md="6" sm="12" style={{ marginBottom: "30px" }}>
            <div>
              <h5 style={sectionTitleStyle}>💉 Aplikasi Donor Darah</h5>
              <p
                style={{
                  color: "rgba(255, 255, 255, 0.8)",
                  fontSize: "0.95rem",
                  lineHeight: "1.8",
                  marginBottom: "20px",
                }}
              >
                Platform digital untuk mengelola informasi stok darah dan
                pendaftaran donor darah di Rote Ndao. Mari bersama-sama
                selamatkan nyawa dengan menjadi pendonor darah.
              </p>
              <div style={{ display: "flex", gap: "15px", marginTop: "20px" }}>
                <a
                  href="#"
                  style={{
                    ...linkStyle,
                    display: "inline-block",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255, 255, 255, 0.1)",
                    textAlign: "center",
                    lineHeight: "40px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#e63946";
                    e.currentTarget.style.transform = "translateY(-3px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.1)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  📘
                </a>
                <a
                  href="#"
                  style={{
                    ...linkStyle,
                    display: "inline-block",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255, 255, 255, 0.1)",
                    textAlign: "center",
                    lineHeight: "40px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#e63946";
                    e.currentTarget.style.transform = "translateY(-3px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.1)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  📷
                </a>
                <a
                  href="#"
                  style={{
                    ...linkStyle,
                    display: "inline-block",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255, 255, 255, 0.1)",
                    textAlign: "center",
                    lineHeight: "40px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#e63946";
                    e.currentTarget.style.transform = "translateY(-3px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.1)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  📺
                </a>
              </div>
            </div>
          </Col>

          <Col lg="3" md="6" sm="12" style={{ marginBottom: "30px" }}>
            <div>
              <h5 style={sectionTitleStyle}>🔗 Tautan Cepat</h5>
              <a
                href="#"
                style={linkStyle}
                onMouseEnter={(e) => (e.target.style.color = "#e63946")}
                onMouseLeave={(e) =>
                  (e.target.style.color = "rgba(255, 255, 255, 0.8)")
                }
              >
                Beranda
              </a>
              <a
                href="#"
                style={linkStyle}
                onMouseEnter={(e) => (e.target.style.color = "#e63946")}
                onMouseLeave={(e) =>
                  (e.target.style.color = "rgba(255, 255, 255, 0.8)")
                }
              >
                Stok Darah
              </a>
              <a
                href="#"
                style={linkStyle}
                onMouseEnter={(e) => (e.target.style.color = "#e63946")}
                onMouseLeave={(e) =>
                  (e.target.style.color = "rgba(255, 255, 255, 0.8)")
                }
              >
                Registrasi Calon Pendonor
              </a>
              <a
                href="#"
                style={linkStyle}
                onMouseEnter={(e) => (e.target.style.color = "#e63946")}
                onMouseLeave={(e) =>
                  (e.target.style.color = "rgba(255, 255, 255, 0.8)")
                }
              >
                Lakukan Donor
              </a>
            </div>
          </Col>

          <Col lg="5" md="12" sm="12" style={{ marginBottom: "30px" }}>
            <div>
              <h5 style={sectionTitleStyle}>📞 Kontak & Informasi</h5>
              <div
                style={{
                  color: "rgba(255, 255, 255, 0.8)",
                  fontSize: "0.95rem",
                  lineHeight: "2",
                }}
              >
                <p style={{ margin: "8px 0" }}>
                  <strong style={{ color: "#ffffff" }}>📍 Alamat:</strong>
                  <br />
                  Unit Transfusi Darah RSUD Ba'a
                  <br />
                  Jl. Raya Ba'a, Kec. Ba'a, Kabupaten Rote Ndao
                </p>
                <p style={{ margin: "8px 0" }}>
                  <strong style={{ color: "#ffffff" }}>📞 Telepon:</strong>{" "}
                  (0381) 1234567
                </p>
                <p style={{ margin: "8px 0" }}>
                  <strong style={{ color: "#ffffff" }}>📧 Email:</strong>{" "}
                  info@donordarah.rotendaokab.go.id
                </p>
                <p style={{ margin: "8px 0" }}>
                  <strong style={{ color: "#ffffff" }}>
                    🕐 Jam Operasional:
                  </strong>
                  <br />
                  Senin - Jumat: 08:00 - 15:00 WITA
                  <br />
                  Sabtu: 08:00 - 12:00 WITA
                </p>
              </div>
            </div>
          </Col>
        </Row>

        <div
          style={{
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            marginTop: "40px",
            paddingTop: "30px",
            textAlign: "center",
          }}
        >
          <p
            style={{
              color: "rgba(255, 255, 255, 0.7)",
              fontSize: "0.9rem",
              margin: "5px 0",
            }}
          >
            © {new Date().getFullYear()} Aplikasi Donor Darah - Rote Ndao
          </p>
          <p
            style={{
              color: "rgba(255, 255, 255, 0.6)",
              fontSize: "0.85rem",
              margin: "5px 0",
            }}
          >
            Dikembangkan oleh Diskominforstatper | Rote Ndao
          </p>
          <p
            style={{
              color: "rgba(255, 255, 255, 0.6)",
              fontSize: "0.85rem",
              margin: "5px 0",
            }}
          >
            Satu Tetes Darahmu, Satu Nyawa Terselamatkan ❤️
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
